export class ButtonReload {

    constructor(reloadButton: HTMLElement) {
        this.reloadAction(reloadButton);
    }

    reloadAction(reloadButton: HTMLElement) {
        reloadButton.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();
            location.reload();
        });
    }
}
